import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { isEqual, isFunction } from 'lodash'

import { CustomCheckBox } from '../../../components/CustomCheckBox'
import { InfoButton } from '../../../components/InfoButton'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { WidgetWrapperType } from '../types'

const WidgetWrapperComponent: FC<WidgetWrapperType> = ({
  isChecked,
  handleCheck,
  explanation,
  label,
  minWidth,
  sx,
  children,
}) => {
  const { spacing, palette } = useTheme()
  useAppDispatch()
  const { customize } = useAppSelector(({ dashboard }) => dashboard)

  const showCheckbox = isFunction(handleCheck)

  return (
    <Box
      minWidth={minWidth}
      height={spacing(26)}
      borderRadius={spacing(0.5)}
      padding={spacing(2)}
      bgcolor={palette.background.paper}
      sx={sx}
      display="flex"
      flex={1}
      position="relative"
    >
      {customize && showCheckbox && (
        <CustomCheckBox
          checked={isChecked}
          sx={{ position: 'absolute', top: spacing(0.5), right: spacing(0.5) }}
          onChange={handleCheck}
        />
      )}
      <Box display="flex" flexDirection="column" flex={1}>
        <Box display="flex" gap={spacing(0.5)}>
          <Typography fontSize={13} fontWeight="bold" color={palette.grey[700]}>
            {label}
          </Typography>
          <InfoButton explanation={explanation} />
        </Box>
        {children}
      </Box>
    </Box>
  )
}

export const WidgetWrapper = React.memo(WidgetWrapperComponent, isEqual)
